import React, { useEffect, useState } from "react";
import { Card, Col, Container, FormGroup, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./Contact.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { imageUpload } from "../../services/BannersServices";
import Dropzone from "react-dropzone";
import { Constants } from "../../Constants";
import { EditorState } from "draft-js";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { stateToHTML } from "draft-js-export-html";
import { useHistory } from "react-router";
import ViewInWeb from "../../components/Common/ViewInWeb";
import axios from "axios";
import { stateFromHTML } from "draft-js-import-html";
import Icon from "@ailibs/feather-react-ts/dist/Icon";
import Direction from "src/components/contact/Direction";

const instance = axios.create({ baseURL: Constants.BASE_URL });

const updateContact = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(
      `/brokers`,
      { ...data, type: "contact_directions" },
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

const fetchDirections = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/directions`, httpOptions);
  } catch (error) {
    throw error;
  }
};

const fetchBanners = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/brokers?type=contact_directions`, httpOptions);
  } catch (error) {
    throw error;
  }
};

type Direction = {
  id?: number;
  nombre: string;
  direccion: string;
  telefono: string;
  horario: string;
  imagen: string;
  email: string;
  lat: string;
  lng: string;
};

function Contact(props: any) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [bannerDesktop, setBannerDesktop] = useState();
  const [bannerMobile, setBannerMobile] = useState();
  const [imageTmp, setImageTmp] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [directions, setDirections] = useState<Direction[]>([]);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchBanners({
        token: "",
      });
      const { banner_desktop, banner_mobile } = response.data.data;
      setBannerDesktop(banner_desktop);
      setBannerMobile(banner_mobile);

      let resp = await fetchDirections({
        token: "",
      });

      setDirections(resp.data.data);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleAcceptedFiles = async (files: any, hook: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "contact_directions",
        });
        if (hook === "banner_desktop") {
          setBannerDesktop(response.data.data.image);
        } else if (hook === "banner_mobile") {
          setBannerMobile(response.data.data.image);
        } else {
          setImageTmp(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let data = {
        bannerDesktop,
        bannerMobile,
      };

      await updateContact({
        token: "",
        ...data,
      });

      setLoading(false);
      toast(`Brokers actualizado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Contacto"
            breadcrumbItem="Contacto"
          />
          <Row>
            <Col className="row">
              <FormGroup className="col-md-6">
                <Label>Banner Desktop</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_desktop");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerDesktop && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerDesktop}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
              <FormGroup className="col-md-6">
                <Label>Banner Mobile</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_mobile");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerMobile && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerMobile}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link={`https://mariomendez.uy/propiedades`} />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar Banners
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <hr style={{ margin: "2rem 0rem" }} />
          <Row>
            <div className="row" style={{ marginTop: "1rem" }}>
              <div className="col-12 text-right">
                <button
                  className="btn btn-primary waves-effect waves-light"
                  onClick={() => setAddNew(!addNew)}
                >
                  {addNew ? "Cancelar" : "Agregar nueva sucursal"}
                </button>
              </div>
            </div>
            {addNew ? (
              <>
                <Direction fetch={fetch} setAddNew={setAddNew} />
                <hr />
              </>
            ) : null}
          </Row>
          <Row>
            <div
              style={{ display: "flex", flexDirection: "column" }}
              className="col-12"
            >
              {directions?.map((d) => (
                <Direction d={d} fetch={fetch} />
              ))}
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Contact;
